import React, { useState } from "react";
import { Link } from "react-router-dom";

/**
 * Banniere de solidarite suite aux incendies meurtriers d'aout 2026
 * (Jijel, Bejaia, Tizi-Ouzou et autres wilayas touchees).
 * Fermable par l'utilisateur (persiste le choix dans le navigateur).
 */
const DISMISS_KEY = "tabbibak_solidarity_banner_dismissed_2026_incendies";

export default function SolidarityBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const handleClose = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      // ignore si localStorage indisponible
    }
  };

  return (
    <div
      role="region"
      aria-label="Message de solidarite"
      style={{
        backgroundColor: "#7f1d1d",
        color: "#ffffff",
        padding: "10px 16px",
        fontSize: "14px",
        lineHeight: "1.5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        flexWrap: "wrap",
        textAlign: "center",
        position: "relative",
      }}
    >
      <style>{`
        @keyframes solidarityPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
      <span style={{ animation: "solidarityPulse 1.8s ease-in-out infinite" }}>
        🕯️ Tabbibak est de tout cœur avec les familles touchées par les incendies
        à Jijel, Béjaïa, Tizi-Ouzou et dans les autres wilayas frappées ces
        derniers jours. Nos pensées vont aux victimes, à leurs proches, et à
        toutes les équipes de la Protection Civile mobilisées.
      </span>
      <Link
        to="/incendies-2026"
        style={{
          color: "#ffffff",
          textDecoration: "underline",
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        En savoir plus →
      </Link>
      <a
        href="https://www.ifrc.org/fr/national-societies-directory/croissant-rouge-algerien"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#ffffff",
          textDecoration: "underline",
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        Faire un don au Croissant-Rouge Algérien
      </a>
      <button
        onClick={handleClose}
        aria-label="Fermer ce message"
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          color: "#ffffff",
          fontSize: "18px",
          cursor: "pointer",
          lineHeight: 1,
          padding: "4px",
        }}
      >
        ×
      </button>
    </div>
  );
}
